"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAdRequestToJSON = exports.UpdateAdRequestFromJSONTyped = exports.UpdateAdRequestFromJSON = exports.instanceOfUpdateAdRequest = void 0;
var runtime_1 = require("../runtime");
var AdAssets_1 = require("./AdAssets");
var AdCallToActionRequest_1 = require("./AdCallToActionRequest");
var AdStatus_1 = require("./AdStatus");
var AdSurvey_1 = require("./AdSurvey");
var AdThirdPartyTracking_1 = require("./AdThirdPartyTracking");
var Delivery_1 = require("./Delivery");
var SlotPositionsInner_1 = require("./SlotPositionsInner");
/**
 * Check if a given object implements the UpdateAdRequest interface.
 */
function instanceOfUpdateAdRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateAdRequest = instanceOfUpdateAdRequest;
function UpdateAdRequestFromJSON(json) {
    return UpdateAdRequestFromJSONTyped(json, false);
}
exports.UpdateAdRequestFromJSON = UpdateAdRequestFromJSON;
function UpdateAdRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'advertiserName': !(0, runtime_1.exists)(json, 'advertiser_name') ? undefined : json['advertiser_name'],
        'assets': !(0, runtime_1.exists)(json, 'assets') ? undefined : (0, AdAssets_1.AdAssetsFromJSON)(json['assets']),
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'tagline': !(0, runtime_1.exists)(json, 'tagline') ? undefined : json['tagline'],
        'thirdPartyTracking': !(0, runtime_1.exists)(json, 'third_party_tracking') ? undefined : (json['third_party_tracking'].map(AdThirdPartyTracking_1.AdThirdPartyTrackingFromJSON)),
        'survey': !(0, runtime_1.exists)(json, 'survey') ? undefined : (0, AdSurvey_1.AdSurveyFromJSON)(json['survey']),
        'slotPositions': !(0, runtime_1.exists)(json, 'slot_positions') ? undefined : (json['slot_positions'].map(SlotPositionsInner_1.SlotPositionsInnerFromJSON)),
        'notaryMetadata': !(0, runtime_1.exists)(json, 'notary_metadata') ? undefined : json['notary_metadata'],
        'dvClientCode': !(0, runtime_1.exists)(json, 'dv_client_code') ? undefined : json['dv_client_code'],
        'callToAction': !(0, runtime_1.exists)(json, 'call_to_action') ? undefined : (0, AdCallToActionRequest_1.AdCallToActionRequestFromJSON)(json['call_to_action']),
        'delivery': !(0, runtime_1.exists)(json, 'delivery') ? undefined : (0, Delivery_1.DeliveryFromJSON)(json['delivery']),
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, AdStatus_1.AdStatusFromJSON)(json['status']),
    };
}
exports.UpdateAdRequestFromJSONTyped = UpdateAdRequestFromJSONTyped;
function UpdateAdRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'advertiser_name': value.advertiserName,
        'assets': (0, AdAssets_1.AdAssetsToJSON)(value.assets),
        'name': value.name,
        'tagline': value.tagline,
        'third_party_tracking': value.thirdPartyTracking === undefined ? undefined : (value.thirdPartyTracking.map(AdThirdPartyTracking_1.AdThirdPartyTrackingToJSON)),
        'survey': (0, AdSurvey_1.AdSurveyToJSON)(value.survey),
        'slot_positions': value.slotPositions === undefined ? undefined : (value.slotPositions.map(SlotPositionsInner_1.SlotPositionsInnerToJSON)),
        'notary_metadata': value.notaryMetadata,
        'dv_client_code': value.dvClientCode,
        'call_to_action': (0, AdCallToActionRequest_1.AdCallToActionRequestToJSON)(value.callToAction),
        'delivery': (0, Delivery_1.DeliveryToJSON)(value.delivery),
        'status': (0, AdStatus_1.AdStatusToJSON)(value.status),
    };
}
exports.UpdateAdRequestToJSON = UpdateAdRequestToJSON;
